export interface Theme {
  config_ral_primary: string;
  config_ral_secondary: string;
}

export const gridlineTheme: Theme = {
  config_ral_primary: 'RAL 7035',
  config_ral_secondary: 'RAL 7016',
};
